import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B02iCustomerManagementPage } from '../b02i-customer-management/b02i-customer-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { updateDate } from 'ionic-angular/umd/util/datetime-util';
import { B09SettingPage } from '../b09-setting/b09-setting';

/**
 * Generated class for the B02ibCustomerInfoPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b09c-corporate-info',
  templateUrl: 'b09c-corporate-info.html',
})
export class B09cCorporateInfoPage {
  private todo : FormGroup;
  loading: any;
  Status: any;
  corpData = {  CORP_NAME:'',
                ADDR1:'', ADDR2:'', ADDR3:'',
                CONTACT_NO: '', EMAIL:'', PIC:'',
                CORP_ACTIVE:'YES',ALERT_BIGUSAGE:'',   
                ALERT_OVERUSE:'', ALERT_FREQUENT:'',
                BIGUSAGE_EMAIL:'YES', OVERUSE_EMAIL:'YES',
                FREQUENT_EMAIL:'YES',
              }
  CORP_ID:any;
  public errorMessage: any = "";

  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder,
              private toastCtrl: ToastController, public loadingCtrl: LoadingController,
              public serviceapi: ServiceApiProvider, public alertCtrl : AlertController) {

        this.todo = this.formBuilder.group({
          name: ['', Validators.required],
          address: ['', Validators.required],
    //      town: ['', Validators.required],
          postCode: ['', Validators.required],
          state: ['', Validators.required],
    //      country: ['', Validators.required],
          phone: ['', Validators.required],
          email: ['', Validators.required],
          pic: ['', Validators.required],
          active: ['', Validators.required],
          bigusage: ['', Validators.required],
          bigusage_email: ['', Validators.required],
          overuse: ['', Validators.required],
          overuse_email: ['', Validators.required],
          frequent: ['', Validators.required],
          frequent_email: ['', Validators.required],
        });

    this.CORP_ID = this.navParams.get('paramID');    //corporate ID

    let tbl = ["CORPORATE"];
    let column = ["CORP_ID"];
    let value = [this.CORP_ID];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();
    this.serviceapi.readdata(json_data,"CORPORATE","1","1").then((result) => {
        
      this.Status = result["Message"];
      console.log(result["Records"]);
      if (this.Status == "1"){
        this.loading.dismiss();

        let Records = result["Records"];
        this.corpData.CORP_NAME = Records[0]["CORP_NAME"];
        this.corpData.ADDR1 = Records[0]["ADDR1"];
        this.corpData.ADDR2 = Records[0]["ADDR2"];
        this.corpData.ADDR3 = Records[0]["ADDR3"];
        this.corpData.CONTACT_NO = Records[0]["CONTACT_NO"];
        this.corpData.EMAIL = Records[0]["EMAIL"];
        this.corpData.PIC = Records[0]["PIC"];
        this.corpData.ALERT_BIGUSAGE = Records[0]["ALERT_BIGUSAGE"];
        this.corpData.ALERT_FREQUENT = Records[0]["ALERT_FREQUENT"];
        this.corpData.ALERT_OVERUSE = Records[0]["ALERT_OVERUSE"];
        this.corpData.BIGUSAGE_EMAIL = Records[0]["BIGUSAGE_EMAIL"];
        this.corpData.FREQUENT_EMAIL = Records[0]["FREQUENT_EMAIL"];
        this.corpData.OVERUSE_EMAIL = Records[0]["OVERUSE_EMAIL"];
        console.log(this.corpData);


      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02ibCustomerInfoPage');
  }

  

  updateUser(){
    console.log(this.corpData);

    this.serviceapi.updatedata('CORPORATE', 'CORP_ID', this.CORP_ID, this.corpData).then((result) => {
        
      this.Status = result["Message"];
      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B09SettingPage);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
    
  }

  goToUser(){
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B09SettingPage);
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b09c-corporate-info/b09c-corporate-info.ts